<template>
  <ValidationObserver
    ref="dropdownObserver" >
    <ValidationProvider
      ref="dropdownProvider"
      v-slot="{ errors }"
      name="test"
      :rules="validators">
      <div class="flex gap-8 wrap">
        <div
          v-for="(option, index) in schema.options"
          :key="index"
          class="no-shrink option flex flex-align-center"
          :class="{ selected: selected === option.value, 'prefix-image': option.image }"
          :style="{ 'background-image': option.image ? `url(${option.image})` : '' }"
          @click="selectOption(option.value)" >
          <span class="greedy ellipsis">{{ option.label }}</span>
          <SBIcon
            v-if="selected === option.value"
            :icon="SBIconList.DONE_CIRCLE"
            :color="SBColors.bluePrimary"
            :size="13"/>
        </div>
      </div>
      <div
        v-if="errors[0]"
        class="error flex flex-align-center">
        <SBIcon
          class="mr-1"
          :icon="SBIconList.ERROR"
          :color="SBColors.redPrimary"
          :size="10" />
        <span>{{ errors[0] }}</span>
      </div>
    </ValidationProvider>
  </ValidationObserver>
</template>

<script>
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';

export default {
  name: 'NMBRRadioWrapper',
  components: {
    SBIcon,
  },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    validators: {
      type: String,
      default: '',
    },
    schema: {
      type: Object,
      default: () => ({}),
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      value: null,
      SBColors,
      SBIconList,
      selected: null,
    };
  },
  computed: { },
  watch: {
    // modelData: {
    //   handler() {
    //     this.emitData();
    //   },
    //   immediate: true,
    // },
  },
  mounted() {
    // console.log('RADIO 1');
    if (this.schema.value) {
      // console.log('RADIO 2', this.schema.value);
      this.selected = this.schema.value;
      this.$nextTick(() => {
        this.$refs.dropdownProvider.syncValue(this.selected);
        this.emitData();
      });
    }
    if (this.schema.stepID) {
      this.$eventBus.$on(`validate-${this.schema.stepID}`, () => {
        if (!this.$refs.dropdownObserver) return;
        this.$refs.dropdownObserver.validate();
      });
    }
    // setTimeout(() => {
    //   this.emitData(true);
    //   if (this.schema.value) {
    //     this.$refs.dropdownObserver.validate();
    //   }
    // }, 0);
  },
  methods: {
    selectOption(index) {
      this.selected = index;
      this.$refs.dropdownProvider.syncValue(this.selected);
      this.emitData();
    },
    emitData(reset = false) {
      // console.log(1);
      if (!this.$refs.dropdownObserver) return;
      // console.log(2);
      this.$refs.dropdownObserver.validate({ silent: true })
        .then((valid) => {
          // console.log(3, valid);
          this.$emit('input', {
            valid,
            name: this.schema.returnKey || '',
            data: {
              ...this.schema.options.find(option => option.value === this.selected),
            },
          });
        })
        .finally(() => {
          if (reset) this.$refs.dropdownObserver.reset();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.option {
  padding: 9px 12px;
  border-radius: 10px;
  box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.1);
  border: solid 1px $greyBorder;
  background-color: $white;
  cursor: pointer;
  flex-basis: calc(50% - 8px); // it is important to have 10px padding which matches the gap between the columns. The last gap will be removed anyway and the columns will stretch due to the flex-grow property.
  flex-grow: 50;
  width: 1px;
  max-height: 34px;

  span {
    font-size: 14px;
    font-weight: 400;
  }

  &.selected {
    background-color: #f0f7ff;
    
    span {
      font-weight: 500;
    }
  }

  &.prefix-image {
    padding-left: 31px;
    background-repeat: no-repeat;
    background-position: 12px center;
    background-size: 14px 14px;
  }
}
</style>
